import React from "react";

const AuthLayout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-gray-100">
      <header className="bg-blue-600 text-white p-4 shadow">
        <h1 className="text-center text-2xl font-bold">Authentication</h1>
      </header>
      <main className="flex-grow">{children}</main>
      <footer className="bg-gray-800 text-white text-center p-4">
        © 2025 My Application
      </footer>
    </div>
  );
};

export default AuthLayout;
